import React from 'react';

import { FilterBottomSheet, useT } from '@repo/common';
import { OPTION_BY_STATUS } from '../CardOptionList';

/**
 * 모바일 공고 관리 상세의 오버플로우(⋮) 메뉴 — 바텀시트.
 * 항목은 데스크탑 드롭다운(CardOptionList)과 같은 상태별 목록을 쓰고, 아이콘은 오른쪽에 둔다.
 */
const MobileDetailOptionSheet = ({ status, onAction, onClose }) => {
  const t = useT();
  const options = OPTION_BY_STATUS[status] ?? [];

  return (
    <FilterBottomSheet fullWidth variant='menu' onClose={onClose}>
      <ul role='menu' className='m-0 flex w-full list-none flex-col p-0'>
        {options.map((option) => (
          <li key={option.key} role='none'>
            <button
              type='button'
              role='menuitem'
              onClick={() => {
                onClose?.();
                onAction?.(option.key);
              }}
              className='flex h-[38px] w-full items-center justify-between rounded-lg py-[10px] pl-3 pr-2 text-left text-text-primary transition-colors hover:bg-grayscale-gray01 active:bg-grayscale-gray01'
            >
              <span className='typo-b14Strong'>
                {t(option.label[0], option.label[1])}
              </span>
              <span className='flex size-4 shrink-0 items-center justify-center text-icon-primary [&>svg]:size-4'>
                {option.icon}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </FilterBottomSheet>
  );
};

export default MobileDetailOptionSheet;
